<div class="h-100 overflow-auto crm-scroll">
  @if (!isLoader) {
    <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3">
      <h4 class="m-0 text-crm">
        {{ contact ? ('contact' | translate) + ' ' + contact.name : ('create_new_contact' | translate) }}
      </h4>
      @if (baseService.isMobile) {
        <app-button (onChangeClick)="onCloseSidebar()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
          <app-icon>close</app-icon>
        </app-button>
      }
    </div>
  }

  @if (!isLoader) {
    <mat-divider class="my-2"></mat-divider>
  }
  @if (isLoader) {
    <div class="d-flex align-items-center h-100 justify-content-center">
      <app-loader size="small"></app-loader>
    </div>
  }
  @if (!isLoader) {
    <div>
      @if (contactForm) {
        <div class="d-flex flex-column gap-3 px-4 py-2" [formGroup]="contactForm">
          <div>
            <app-text-field
              label="{{ 'first_name' | translate }}"
              [formControl]="contactForm.controls.name"
              placeholder="{{ 'enter_first_name' | translate }}"
              [required]="true"
              [error]="contactForm.controls.name.touched && !contactForm.controls.name.value"
              (focusout)="contactForm.controls.name.markAsTouched()"
            ></app-text-field>
            @if (contactForm.controls.name.touched && contactForm.controls.name.invalid) {
              <mat-hint class="text-danger">
                @if (contactForm.controls.name.errors?.['required']) {
                  {{ 'field_cannot_be_empty' | translate }}
                }
              </mat-hint>
            }
          </div>
          <app-phone-field
            label="{{ 'phone' | translate }}"
            [formControl]="contactForm.controls.phone"
            placeholder="{{ 'enter_phone_number' | translate }}"
            [error]="contactForm.controls.phone.invalid"
          ></app-phone-field>
          <div>
            <app-text-field
              label="{{ 'mail' | translate }}"
              [formControl]="contactForm.controls.email"
              placeholder="{{ 'enter_your_e-mail' | translate }}"
              (focusout)="contactForm.controls.email.markAsTouched()"
              [error]="contactForm.controls.email.invalid"
            ></app-text-field>
            @if (contactForm.controls.email.touched && contactForm.controls.email.invalid) {
              <mat-hint class="text-danger">
                @if (contactForm.controls.email.errors?.['email']) {
                  {{ 'email_format_is_incorrect' | translate }}
                }
              </mat-hint>
            }
          </div>
          <app-google-address-textfield
            label="{{ 'address' | translate }}"
            [formControl]="contactForm.controls.address"
            placeholder="{{ 'enter_the_address' | translate }}"
            [isError]="contactForm.controls.address.invalid"
          ></app-google-address-textfield>
          <div class="d-flex flex-column">
            <label class="label">{{ 'comment' | translate }}</label>
            <textarea
              class="pt-2 area-border crm-scroll p-2"
              id="text-area"
              type="text"
              maxlength="5000"
              [formControl]="contactForm.controls.comment"
            ></textarea>
            <div class="d-flex flex-row justify-content-between align-items-center">
              <div>
                @if (contactForm.controls.comment.errors?.['maxlength']) {
                  <div class="text-danger notify-of-size">{{ 'max_characters' | translate }} 5000.</div>
                }
              </div>
              <div>
                <mat-hint align="end">{{ contactForm.controls.comment.value?.length || 0 }}/5000</mat-hint>
              </div>
            </div>
          </div>
        </div>
      }
      <!--    <div class="bg-white d-flex position-sticky bottom-0 gap-2 p-4" [ngClass]="{'d-flex justify-content-between': contact}">-->
      <!--      <app-button [customClass]="'bg-danger'" class="mt-2" (onChangeClick)="onNoClick()">{{ 'cancel' | translate }}</app-button>-->
      <!--      <div class="flex-fill"></div>-->
      <!--      <app-button-->
      <!--        class="mt-2"-->
      <!--        (onChangeClick)="onSaveContact()"-->
      <!--        [disabled]="contactForm.invalid"-->
      <!--      >{{ 'save' | translate }}-->
      <!--      </app-button>-->
      <!--      <app-button-->
      <!--        *ngIf="contact"-->
      <!--        class="mt-2"-->
      <!--        [customClass]="'bg-danger'"-->
      <!--        (onChangeClick)="onDeleteContact()"-->
      <!--      >{{'delete' | translate}}-->
      <!--      </app-button>-->
      <!--    </div>-->
      <div class="bg-white d-flex position-sticky bottom-0 gap-2 p-4">
        <app-button [customClass]="'bg-danger'" class="mt-2" (onChangeClick)="onNoClick()">{{
          'cancel' | translate
        }}</app-button>
        <div class="flex-fill"></div>
        <app-button class="mt-2" (onChangeClick)="onSaveContact()" [disabled]="contactForm.invalid">{{
          'save' | translate
        }}</app-button>
        @if (contact) {
          <app-button class="mt-2" [customClass]="'bg-danger'" (onChangeClick)="onDeleteContact()"
            >{{ 'delete' | translate }}
          </app-button>
        }
      </div>
    </div>
  }
</div>
